// Licensing data shown on the /copyright page.
//
// Every author's material is published under DEFAULT_LICENSE unless the author
// asked for something else. To record such a request, add the author to the
// matching entry in AUTHOR_LICENSES (`id` is the author's ID, used for the link
// to their questions page).

export type LicenseCode = "CC BY 4.0" | "CC BY-ND 4.0" | "CC BY-SA 4.0" | "CC BY-NC 4.0" | "CC BY-NC-SA 4.0" | "CC BY-NC-ND 4.0";

export interface LicenseInfo {
  code: LicenseCode;
  /** Full English name, as published by Creative Commons. */
  name: string;
  url: string;
  /** Key under legal.copyright.licenses.* with the plain-language summary. */
  summaryKey: string;
}

export const LICENSES: Record<LicenseCode, LicenseInfo> = {
  "CC BY 4.0": {
    code: "CC BY 4.0",
    name: "Attribution 4.0 International",
    url: "https://creativecommons.org/licenses/by/4.0/",
    summaryKey: "by",
  },
  "CC BY-ND 4.0": {
    code: "CC BY-ND 4.0",
    name: "Attribution-NoDerivatives 4.0 International",
    url: "https://creativecommons.org/licenses/by-nd/4.0/",
    summaryKey: "byNd",
  },
  "CC BY-SA 4.0": {
    code: "CC BY-SA 4.0",
    name: "Attribution-ShareAlike 4.0 International",
    url: "https://creativecommons.org/licenses/by-sa/4.0/",
    summaryKey: "bySa",
  },
  "CC BY-NC 4.0": {
    code: "CC BY-NC 4.0",
    name: "Attribution-NonCommercial 4.0 International",
    url: "https://creativecommons.org/licenses/by-nc/4.0/",
    summaryKey: "byNc",
  },
  "CC BY-NC-SA 4.0": {
    code: "CC BY-NC-SA 4.0",
    name: "Attribution-NonCommercial-ShareAlike 4.0 International",
    url: "https://creativecommons.org/licenses/by-nc-sa/4.0/",
    summaryKey: "byNcSa",
  },
  "CC BY-NC-ND 4.0": {
    code: "CC BY-NC-ND 4.0",
    name: "Attribution-NonCommercial-NoDerivatives 4.0 International",
    url: "https://creativecommons.org/licenses/by-nc-nd/4.0/",
    summaryKey: "byNcNd",
  },
};

export const DEFAULT_LICENSE: LicenseCode = "CC BY-NC-ND 4.0";

export interface LicensedAuthor {
  id?: number;
  name: string;
}

/** Authors who chose a license other than DEFAULT_LICENSE. */
export const AUTHOR_LICENSES: Partial<Record<LicenseCode, LicensedAuthor[]>> = {
  // "CC BY-ND 4.0": [{ id: 123, name: "Ad Soyad" }],
};

/** Custom (non-Creative Commons) terms agreed with individual authors or clubs. */
export const CUSTOM_LICENSES: { title: string; authors: LicensedAuthor[]; terms: string }[] = [];
